module.exports = __webpack_public_path__ + "static/media/no-image.57da1720.jpg";